/** As long as the server keeps a reply (`IdempotencyInterceptor`). */
const KEY_TTL_MS = 15 * 60_000;

const keys = new Map<string, { key: string; expiresAt: number }>();

/**
 * `Idempotency-Key` of a create, reused while the same request is left without
 * an answer (VOL-324): the coach's retry after a timeout sends the same key, and
 * the server returns what it created the first time instead of a duplicate.
 */
export function idempotencyKeyFor(fingerprint: string, now = Date.now()): string {
    for (const [print, entry] of keys) {
        if (entry.expiresAt <= now) keys.delete(print);
    }
    const existing = keys.get(fingerprint);
    if (existing) return existing.key;
    const key = crypto.randomUUID();
    keys.set(fingerprint, { key, expiresAt: now + KEY_TTL_MS });
    return key;
}

/** The server answered: sending the same body again is a new create. */
export function releaseIdempotencyKey(fingerprint: string): void {
    keys.delete(fingerprint);
}
